import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import NavItem from "./NavItem";
import Sidebar from "./Sidebar";


function MobileLeftBar({ open = false, onButtonClick, onThemeChange }) {
    const auth = useSelector(state => state.amplifyUser);
    const userData = auth.user?.attributes;
    const [show, setShow] = useState(open);

    const handleClose = () => {
        setShow(false);
        onButtonClick();
    }
    return (
        <>
            {show &&
                <>
                    <div className='mobile-menu-bar'>
                        <div className="mobile-menu-title">

                            <a role="button" className="right-bar-toggle float-right" onClick={handleClose}>
                                <i className="fa fa-times"></i>
                            </a>
                            <h5 className="m-0">Menu</h5>
                        </div>
                        <Sidebar handleClose={handleClose} userData={userData}/>
                    </div>

                    <div class="rightbar-overlay"></div>
                </>
            }

        </>
    )


}

export default MobileLeftBar;